import { render, staticRenderFns } from "./STableExpensesComp.vue?vue&type=template&id=0e407f6e&"
import script from "./STableExpensesComp.vue?vue&type=script&lang=js&"
export * from "./STableExpensesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports